import apiClient from './apiClient'


const getSocialMediaPost = (tenant, projectId, id) => {
  return apiClient.get(`/${tenant}/SocialMediaPost/${projectId}/${id}`)
}

const getSocialMediaPosts = (tenant, projectId) => {
  return apiClient.get(`/${tenant}/SocialMediaPost/${projectId}`)
}

const createSocialMediaPost = (tenant, projectId, socialMediaPost) => {
  return apiClient.post(`/${tenant}/SocialMediaPost/${projectId}`, socialMediaPost)
}

const updateSocialMediaPost = (tenant, projectId, id, socialMediaPost) => {
  return apiClient.put(`/${tenant}/SocialMediaPost/${projectId}/${id}`, socialMediaPost)
}

const deleteSocialMediaPost = (tenant, projectId, id) => {
  return apiClient.delete(`/${tenant}/SocialMediaPost/${projectId}/${id}`)
}

const publishSocialMediaPost = (tenant, projectId, id) => {
  return apiClient.put(`/${tenant}/SocialMediaPost/${projectId}/${id}/Publish`)
}


export default {
  getSocialMediaPost,
  getSocialMediaPosts,
  createSocialMediaPost,
  updateSocialMediaPost,
  deleteSocialMediaPost,
  publishSocialMediaPost
}
